import React from 'react';
import Link from 'next/link';


interface FooterLink {
  label: string;
  href: string;
}

interface FooterSection {
  title: string;
  links: FooterLink[];
}

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerSections: FooterSection[] = [
    {
      title: "Quick Links",
      links: [
        { label: "Home", href: "/" },
        { label: "Available Puppies", href: "/available-puppies" },
        { label: "About Us", href: "/about-us" },
        { label: "Contact", href: "/contact-us" }
      ]
    },
    {
      title: "Resources",
      links: [
        { label: "Blog", href: "/blog" },
        { label: "Testimonials", href: "/customer-testimonials" },
        { label: "Health Guarantee", href: "/health-guarantee" },
        { label: "FAQ", href: "/contact-us" }
      ]
    },
    {
      title: "Contact",
      links: [
        { label: "Email: contact@luminexlabradors.com", href: "mailto:contact@luminexlabradors.com" },
        { label: "Location: Trenton, NJ", href: "/contact-us" }
      ]
    }
  ];

  const socialLinks = [
    { name: "Facebook", icon: "ShareIcon", href: "#" },
    { name: "Instagram", icon: "CameraIcon", href: "#" },
    { name: "Twitter", icon: "ChatBubbleLeftIcon", href: "#" }
  ];

  return (
    <footer className="border-t border-border bg-card py-12">
      <div className="container mx-auto px-4">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {/* Brand Section */}
          <div className="space-y-4">
            <Link href="/" className="flex items-center gap-3 transition-smooth hover:opacity-80">
              <div className="flex h-12 w-12 items-center justify-center overflow-hidden rounded-full bg-primary">
                <img
                  src="/assets/images/lap_dog-1769787911131.jpg"
                  alt="Luminex Labradors Logo - Labrador Dog"
                  className="h-full w-full object-cover"
                  loading="lazy"
                  decoding="async"
                  width="48"
                  height="48"
                />
              </div>
              <div className="flex flex-col">
                <span className="font-heading text-xl font-bold leading-tight text-foreground">
                  LuminexLabradors
                </span>
                <span className="caption text-xs text-muted-foreground">
                  Quality Labrador Breeders
                </span>
              </div>
            </Link>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="mb-4 font-heading text-lg font-semibold text-foreground">
              Quick Links
            </h3>
            <nav aria-label="Footer navigation">
              <ul className="space-y-2">
                {footerSections[0].links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <Link
                      href={link.href}
                      className="text-sm text-muted-foreground transition-smooth hover:text-primary"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          {/* Resources */}
          <div>
            <h3 className="mb-4 font-heading text-lg font-semibold text-foreground">
              Resources
            </h3>
            <nav aria-label="Footer navigation">
              <ul className="space-y-2">
                {footerSections[1].links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <Link
                      href={link.href}
                      className="text-sm text-muted-foreground transition-smooth hover:text-primary"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="mb-4 font-heading text-lg font-semibold text-foreground">
              Contact Information
            </h3>
            <nav aria-label="Footer navigation">
              <ul className="space-y-2">
                {footerSections[2].links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <Link
                      href={link.href}
                      className="text-sm text-muted-foreground transition-smooth hover:text-primary"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 border-t border-border pt-8">
          <div className="flex flex-col items-center justify-between gap-4 text-sm text-muted-foreground md:flex-row">
            <p>
              © {currentYear} LuminexLabradors. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link href="/privacy-policy" className="transition-smooth hover:text-primary">
                Privacy Policy
              </Link>
              <Link href="/terms-of-service" className="transition-smooth hover:text-primary">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;